<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_12"></a><a id="section1"></a>SECTION ONE</h2>
<h2 class="h2a">LET THE COWS COME HOME!</h2>
<h2 class="h2b">FOOLPROOF SUBSTITUTIONS FOR DAIRY</h2>
<p class="noindent"><img alt="Image" src="images/f0002-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section1.vue?3cbf9793